import { useQuery } from 'react-query';
import { getJSON } from '../api/http';
import { endpoints } from '../api/endpoints';


interface IAcsDataTesty {
    Download: number | null;
    DownloadTimeStamp: number;
    Upload: number | null;
    UploadTimeStamp: number;
    WiFi: number | null;
    WiFiTimeStamp: number;
}

export interface IAcsData {
    ExtId: string;
    Tags: string;
    LastUpdate: number;
    LastInform: number;
    LastBoot: number;
    LastBootstrap: number;
    Registered: number;
    Model: string | null;
    MAC: string | null;
    SerialNumber: string;
    ProductClass: string;
    OUI: string;
    Manufacturer: string;
    Serial: string;
    Producent: string;
    "Ethernet Ports": number | null; // keeping the exact key
    Testy: IAcsDataTesty;
    status: number
}



export const restructureTr069AcsData = ({ LastUpdate, LastBoot, LastBootstrap, LastInform, status }: IAcsData) => ({
    lastSeen: LastInform,
    lastRestart: LastBoot,
    lastConfigChange: LastBootstrap,
    lastDataUpdate: LastUpdate,
    status
})


const getTr069AcsData = async (id: string) =>
    getJSON(endpoints.devices.tr069.acsData.replaceAll("{id}", id));

export const useTr069AcsData = (id: string) => {
    const { data, isLoading, error } = useQuery(
        'Tr069AcsData' + id,
        () => getTr069AcsData(id),
        {
            staleTime: Infinity,
        }
    );

    return {
        isLoading,
        acsData: restructureTr069AcsData(data?.data || {}),
        error,
    };
};
